const invitationPreviewModal = {
  header: "Preview & Edit Invitation Email",
  envelope: {
    from: "From:",
    to: "To:",
    cc: "CC:",
    subject: "Subject:",
    ccNotice: "(you will receive a copy)",
  },
  body: {
    greetingWithName: "Hello {{name}},",
    greetingWithEmail: "Hello {{email}},",
    project:
      "You have been invited to join a research project.\n\nProject: {{project}}\nInvited By: {{inviter}}\n\nClick the link below to accept the invitation and gain access to the project.",
    redirect:
      "{{inviter}} has forwarded a data request to you and is requesting your help.\n\nRequest Title: {{title}}\n\nPlease review the request and respond at your earliest convenience.",
    uploader:
      "You have been invited to upload data for a research project.\n\n{{inviter}} is requesting data for the {{project}} project.\n\nPlease use the link below to securely upload your data. ",
  },
  subject: {
    project: "You've Been Invited to Join Project: {{project}}",
    redirect: "Data Request Forwarded to You",
    uploaderWithProject: "Data Upload Request: {{project}}",
    uploaderNoProject: "Data Upload Request",
  },
  actionLabel: {
    project: "Accept Invitation",
    redirect: "View Request",
    uploader: "Upload Data",
  },
  summary: {
    project: "{{inviter}} invited you to collaborate on '{{project}}'",
    redirect: "{{inviter}} forwarded a data request: '{{title}}'",
    uploaderWithProject: "{{inviter}} is requesting data for the '{{project}}' project",
    uploaderNoProject: "{{inviter}} is requesting data for the research project",
  },
  editableBodyLabel: "Email body — edit freely",
  footer: {
    serviceName: "Pseudonymization Service — Secure Data Pseudonymization",
    automatedNotice: "This is an automated notification. Please do not reply to this email.",
  },
  resetToDefault: "Reset to default",
  sendButton: "Send Invitation",
};

export default invitationPreviewModal;
